import {Component, OnInit} from '@angular/core';
// import {DocumentDetailsFormComponent} from "../../main/documents/document-details-form/document-details-form.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MdbButtonComponent} from "../mdb-button/mdb-button.component";
import {MdbFileUploadModule} from "mdb-angular-file-upload";
import {ModalComponent} from "../modal/modal.component";
import { NgTemplateOutlet } from "@angular/common";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {ValidationErrorComponent} from "../validation-error/validation-error.component";
import {ConflictModel} from "../../../models/conflict.model";
import {MdbModalRef} from "mdb-angular-ui-kit/modal";
import {CheckboxInputComponent} from "../checkbox-input/checkbox-input.component";
import {MdbCheckboxModule} from "mdb-angular-ui-kit/checkbox";
import {MdbRadioModule} from "mdb-angular-ui-kit/radio";

@Component({
    selector: 'app-handle-update-conflict-modal',
    imports: [
    // DocumentDetailsFormComponent,
    FormsModule,
    MdbButtonComponent,
    MdbFileUploadModule,
    ModalComponent,
    TranslateModule,
    ValidationErrorComponent,
    NgTemplateOutlet,
    CheckboxInputComponent,
    MdbCheckboxModule,
    ReactiveFormsModule,
    MdbRadioModule
],
    templateUrl: './handle-update-conflict-modal.component.html',
    styleUrl: './handle-update-conflict-modal.component.scss'
})
export class HandleUpdateConflictModalComponent implements OnInit {
  // input
  rootConflict!: ConflictModel

  selectChanges: boolean = false
  conflicts: ConflictModel[] = []
  selectedValues: { [key: string]: any } = {}; // Store selected values for each field

  constructor(public ref: MdbModalRef<ModalComponent>,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.rootConflict.conflictChildren?.forEach(conflict => {
      this.iterateConflicts(conflict)
    })
    this.initializeSelectedValues()
  }

  iterateConflicts(conflict: ConflictModel, parentPath: string = '', index: any = null) {
    // Construct the full name path
    let fullName = parentPath ? `${parentPath}.${conflict.name ?? index}` : '' +(conflict.name ?? index)

    if (!conflict.conflictChildren || conflict.conflictChildren.length === 0) {
      // Store the conflict with its full path
      this.conflicts.push({ ...conflict, fullName })
      conflict.fullName = fullName
    }

    conflict.conflictChildren?.forEach((c, index) => {
      this.iterateConflicts(c, fullName, conflict.isArray ? index : null)
    })
  }

  initializeSelectedValues() {
    this.selectedValues = {}; // Reset values
    this.conflicts.forEach((conflict: ConflictModel) => {
      // Default to clientValue
      this.selectedValues[conflict.fullName!] = conflict.clientValue!;
    });
  }

  valueToString(value: any): string {
    if (typeof value === "boolean"){
      return this.translate.instant(value ? 'YES' : 'NO')
    }

    return value
  }

  protected readonly window = window;
}
